import { Components, Theme } from '@mui/material'

const MuiSwitch: Components<Theme>['MuiSwitch'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: 42,
      height: 24,
      padding: 0,
      margin: 0,
      marginRight: 10,

      '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: '3px 1px 3px 3px',
        transitionDuration: '300ms',

        '&.Mui-disabled + .MuiSwitch-track': {
          backgroundColor: theme.backgrounds.backgroundTwo,
          opacity: 1,
        },

        '&.Mui-disabled': {
          backgroundColor: theme.backgrounds.backgroundFour,
          opacity: 1,
        },

        '&.Mui-checked': {
          margin: '3px 1px 3px 1px',
          transform: 'translateX(20px)',
          color: theme.colors.white,

          '& + .MuiSwitch-track': {
            backgroundColor: theme.colors.green,
            opacity: 1,
            border: 0,
          },

          '&.Mui-disabled + .MuiSwitch-track': {
            backgroundColor: theme.colors.green,
            opacity: 0.5,
          },

          '&.Mui-disabled': {
            color: theme.colors.white,
            opacity: 1,
          },
        },

        '&.Mui-focusVisible .MuiSwitch-thumb': {
          color: theme.colors.green,
          border: `6px solid ${theme.colors.white}`,
        },
      },

      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 18,
        height: 18,
      },

      '& .MuiSwitch-track': {
        borderRadius: 24 / 2,
        backgroundColor: theme.backgrounds.backgroundTwo,
        opacity: 1,
      },
    }),
  },
}

export default MuiSwitch
